/**
 * Utility function to clean and sanitize HTML content
 * @param {string} html - The HTML content to clean
 * @returns {string} - The cleaned HTML content
 */
export const cleanHtmlContent = (html) => {
    if (!html) return ''
    
    // Remove markdown code block markers
    let cleaned = html.replace(/```html/g, '').replace(/```/g, '')
    
    // Remove any surrounding quotes if present
    cleaned = cleaned.replace(/^["']|["']$/g, '')
    
    // Remove any double escaping of HTML entities
    cleaned = cleaned.replace(/&/g, '&')
    cleaned = cleaned.replace(/</g, '<')
    cleaned = cleaned.replace(/>/g, '>')
    cleaned = cleaned.replace(/"/g, '"')
    cleaned = cleaned.replace(/&#39;/g, "'")
    
    // Remove any extra whitespace
    cleaned = cleaned.trim()
    
    return cleaned
}
